















import { Component } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import BusinessDetailsForm from '@/componentsV2/templates/BusinessDetailsForm/BusinessDetailsForm.vue';
import { isOauthSession } from '@/router/router-utils';

import InternationalizationService from '@/api/InternationalizationService';
import { scrollToTop } from '@/utils/scrollToTop';
import { OnboardingURL } from '@/views/Onboarding/helpers';
import segmentIo from '@/utils/segment.io';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';

@Component({
  components: {
    BusinessDetailsForm
  }
})
export default class StoreDetails extends BusinessOnboardingModel {
  signUpService: SignUpService = new SignUpService();
  internationalizationService = new InternationalizationService();

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get oauthSession() {
    return isOauthSession();
  }

  get defaultFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get needsToComplete() {
    return this.$route.path.includes('complete');
  }

  mounted() {
    scrollToTop('bo-base-layout__right');
  }

  goBack() {
    if (this.needsToComplete) {
      this.$router.push(OnboardingURL.YOUR_BUSINESS_ADDRESS);
      return;
    }
    this.$router.push(OnboardingURL.YOUR_BUSINESS_PREVIEW);
  }

  async onSubmit(formData: Record<string, any>) {
    this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', formData);
    this.saveBusinessLead();

    this.$router.push(OnboardingURL.YOUR_BUSINESS_PREVIEW);
  }

  created() {
    let pageName = 'BFR Sign Up/Business Info Edit';

    if (this.needsToComplete)
      pageName = 'BFR Sign Up/Business Form Manual Input';
    segmentIo.page(pageName, {
      'Direct Link': true
    });
  }
}
